<template>
    <div class="">  
        <section>           	       
            <div class="tab-pane fade show active" 
                id="pills-home" 
                role="tabpanel"                 
				aria-labelledby="pills-home-tab">  				
					<table class="table table-borderless table-responsive-sm">
						<thead >
							<tr>
							<th scope="col">Date</th>
							<th scope="col">Product</th>
							<th scope="col">Source</th>
							<th scope="col">Destination</th>
							<th scope="col">Reason</th>                  
							<th scope="col"></th>
							</tr>
						</thead>      		        				
						<tbody>
							<tr v-for = "(transfer,index) in transfers" :key="index">                            
								<td>{{transfer.date | dateformat}}</td>
								<td>{{transfer.product_name}}</td>
								<td>-</td>
								<td>-</td>
								<td>{{transfer.reason}}</td>                                               
								<td>
									<span class="d-none hidden mt-0" style="position:absolute;right: 0px;">
										<span style="height: 25px; visibility: hidden">hidden</span>
										<span class="d-flex">
											<button class="btn btn-sm btn-success" 
												>
												view receipt
											</button>
											<button class="ml-2 btn btn-sm btn-danger">remove</button>
										</span>										
									</span>
								</td>                            
							</tr>                   
						</tbody>
					</table>                 
            </div>
        </section>
    </div>
</template>
<script>
export default {
        name: 'stockTransfers',
        props: {
            msg: String
        },
        data(){
            return{
                transfers:null,    
            }
        },
        mounted(){    
            this.getTransfers()            
        },
        methods:{		
            //get_products
            getTransfers: function(){            
                this.$http({
                    method:'get',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/transfers/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },                   
                }).then((response)=>{
                    this.transfers = response.data
                }).catch((err)=>{
                    alert(err)
                })
            },
        }
    }
</script>
          